export default __webpack_public_path__ + "static/media/stud-labs-banner.7ac1294b.jpg";